__turbopack_context__.v({
  "lostAccess": "AuthWallets-module-scss-module__URmduW__lostAccess",
  "storeText": "AuthWallets-module-scss-module__URmduW__storeText",
});
